import type { AuthServiceInterface } from '@acme/domains';
import { useAuth, useUser } from '@acme/domains';
import { AdminRoutes } from '@shared/routes';
import type { Certificate } from 'crypto-pro';
import { useNavigate } from 'react-router-dom';

interface UseAuthOptions {
  authService: AuthServiceInterface;
  onSuccessRedirect?: () => void;
  onErrorRedirect?: (error: string) => void;
}

interface UseAuthReturn {
  auth: (
    selectedCertificate: Certificate,
    secret: any,
    password?: string,
    role?: any
  ) => Promise<void>;
  loading: boolean;
  error: string | null;
  remainingCountOfPasswordAttempts?: number | null;
}

export const useAuthWithRedirect = ({
  authService,

  onErrorRedirect,
}: UseAuthOptions): UseAuthReturn => {
  const { login } = useUser();
  const navigate = useNavigate();

  return useAuth({
    authService,
    login,
    onSuccessRedirect: () => {
      navigate('/dashboard');
    },
    onErrorRedirect: (error) => {
      if (onErrorRedirect) {
        onErrorRedirect(error);
      } else {
        navigate(AdminRoutes.auth.authError.path, {
          state: { error },
        });
      }
    },
  });
};
